import axios from "axios";
import moment from "moment";
import { Component } from "react";
import { Button, Card, Col, Form, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import ConfirmModal from '../../utils/ConfirmModal';
import { validateEditExpenseHeaderForm } from "../../utils/validation";
import CommonTableModule from "../CommonTable/CommonTableModule";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";
const { REACT_APP_BACKEND_URL } = process.env;
export default class EditExpenseHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedExpense: null,
      newStatus: "",
      data: this.props.location.state?.data,
      expId: this.props.location.state?.data?.id || null,
      empId: this.props.location.state?.data?.empid || null,
      projectName: this.props.location.state?.data?.project_name || null,
      fullName: this.props.location.state?.data?.fullName,
      completed: '',
      projects: [],
      categoryDataArray: [],
      loading: false,
      categoryId: '',
      hasError: false,
      errMsg: "",
      startDate: null,
      uploadDoc: '',
      endDate: '',
      selectedDate: '',
      selectedProject: '',
      categoryData: [],
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      showForm: false,
      expenseDataArr: [],
      expDataByExpId: [],
      ExpenseDate: null,
      editAction: false,
      rowID: null,
      showConfirm: false,
      deleteId: null,
      fromDate: null,
      toDate: null,
    };
  }


  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };


  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  handleCategoryChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    this.setState({ [name]: value });

    if (!value) {
      errors[name] = "Project selection is required";
    } else {
      delete errors[name];
    }

    this.setState({ errors });
  };

  async componentDidMount() {
    this.fetchCategoryData();
    this.fetchExpenseDetailsByExpId();
  }

  fetchCategoryData = () => {
    this.setState({ loading: true })
    axios({
      method: 'get',
      url: `expenseCategory/list`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        console.log("res.data", res.data);
        this.setState({ categoryDataArray: res.data, loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
        console.log("error is here", err)
      })
  }

  fetchExpenseDetailsByExpId = () => {
    this.setState({ loading: true })
    axios({
      method: 'get',
      url: `/expenseDetails/list/${this.state.expId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        const expenseDetails = res.data.data;
        const dates = expenseDetails.map((item) => new Date(item.date));
        const fromDate = new Date(Math.min(...dates));
        const toDate = new Date(Math.max(...dates));
        const formatDDMMYYYY = (date) => {
          const dd = String(date.getDate()).padStart(2, "0");
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const yyyy = date.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        };
        this.setState({
          expDataByExpId: res.data?.data,
          expenseDetails,
          fromDate: formatDDMMYYYY(fromDate),
          toDate: formatDDMMYYYY(toDate),
          loading: false
        })
      })
      .catch(err => {
        this.setState({ loading: false })
        console.log("error is here", err)
      })
  }



  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/expense-header-list");
      this.setState({ loading: false });
    }, 500);
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };

    if (name === "amount") {
      if (!/^\d{0,8}$/.test(value)) {
        return;
      }
    }

    if (value.trim()) {
      delete errors[name];
    }

    this.setState({
      [name]: value,
      errors
    });
  };




  // handleOpenFormData = () => {
  //   this.setState((prevState) => ({
  //     showForm: !prevState.showForm
  //   }));
  // }
  handleDateChange = (date) => {
    this.setState((prevState) => {
      let errors = { ...prevState.errors };

      if (!date) {
        errors.ExpenseDate = "Expense Date is required";
      } else {
        delete errors.ExpenseDate;
      }

      return { ExpenseDate: date, errors };
    });
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({ uploadDoc: file });
  };


  onSubmit = async (e) => {
    e.preventDefault();
    //debugger;
    this.setState({ hasError: false, errMsg: "", completed: false, loading: true });

    // Validate form
    const errors = validateEditExpenseHeaderForm(
      this.state.categoryId,
      this.state.description,
      this.state.amount,
      this.state.ExpenseDate
    );

    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const formData = new FormData();
      formData.append("expid", this.state.expId);
      formData.append("category_id", this.state.categoryId);
      formData.append("description", this.state.description);
      formData.append("amount", this.state.amount);
      formData.append("date", moment(this.state.ExpenseDate).format("YYYY-MM-DD"));

      if (this.state.uploadDoc) {
        formData.append("document", this.state.uploadDoc); // Append file if available
      }

      let userResponse;
      if (this.state.rowID) {
        userResponse = await axios.put(`/expenseDetails/update/${this.state.rowID}`, formData, { headers });
      } else {
        userResponse = await axios.post("/expenseDetails/add", formData, { headers });
      }

      this.setState(
        {
          completed: true,
          toastMessage: userResponse?.data?.message,
          toastVariant: "success",
          showModal: false,
          color: "green",
          showToast: true,
        },
        async () => {
          this.setState({ selectedProjectId: "", startDate: "", errors: {} });

          // Fetch updated expense details after successful update
          if (this.state.completed) {
            await this.fetchExpenseDetailsByExpId();
          }
        }
      );

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 1000);
    } catch (error) {
      console.error("Error:", error);

      this.setState({
        hasError: true,
        errMsg: error.response?.data?.error || "Something went wrong",
        toastMessage: error.response?.data?.error || "Something went wrong",
        toastVariant: "danger",
        color: "red",
        showToast: true,
      });

      setTimeout(() => {
        this.setState({
          loading: false,
          showToast: false,
          selectedProjectId: "",
          startDate: "",
          errors: {},
        });
      }, 1000);

      window.scrollTo(0, 0);
    }
  };



  handleEditClick = (rowData) => {
    console.log("Clicked row data:", rowData);
    this.setState({
      editAction: true
    })
    if (!rowData) {
      console.error("rowData is undefined!");
    } else {
      this.setState({
        rowID: rowData?.id,
        description: rowData?.description,
        ExpenseDate: rowData?.date ? moment(rowData.date).toDate() : null,
        amount: rowData?.amount,
        categoryId: rowData?.category_id
      })
    }
  };


  handleDelete = async () => {
    this.setState({ loading: true, completed: false });

    const { deleteId } = this.state;
    const token = localStorage.getItem("token");

    try {
      await axios.delete(`/expenseDetails/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState({
        showToast: true,
        toastMessage: "Expense deleted successfully",
        toastVariant: "success",
        completed: true,
        color: "green",
        showConfirm: false,
        deleteId: null,
      },
        async () => {
          // Fetch updated expense details after successful update
          if (this.state.completed) {
            await this.fetchExpenseDetailsByExpId();
          }
        }
      );

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
      //this.fetchLabours(); // Refresh the data
      // await this.fetchExpenseDetailsByExpId()
    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error deleting labour",
        toastVariant: "danger",
        color: "red",
        showConfirm: false,
        deleteId: null,
        loading: false,
      });
    }
  };

  handleStatusChange = (data) => {
    this.setState({ showModal: true, selectedExpense: data, newStatus: data.status });
  };



  handleStatusUpdate = () => {

    const { selectedExpense, newStatus, expId } = this.state;

    console.log("selectedExpense", selectedExpense)
    if (newStatus !== 'Approved' && newStatus !== 'Rejected') {
      this.setState({ showToast: true, toastMessage: "Please select a status!", toastVariant: "danger", color: 'red' });
      return;
    }
    axios.put(`/expenseHeader/status/${selectedExpense.id}`, { status: newStatus }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        console.log("API Success Response:", res);
        this.setState({
          showToast: true,
          toastMessage: "Status updated successfully!",
          toastVariant: "success",
          color: 'green',
          showModal: false
        });
      })
      .catch((err) => {
        console.error("API Error Response:", err.response || err.message);
        this.setState({
          showToast: true,
          toastMessage: "Failed to update status!",
          toastVariant: "danger",
          color: 'red'
        });
      });
  }





  render() {
    const { viewPage } = this.props.location.state || {}
    const { editAction } = this.props.location.state || {}
    const { fromDate, toDate } = this.state;
    // expDataByExpId
    // console.log("from edit", editAction);
    // console.log("from view", editAction);
    const columns = [
      // { key: "id", label: "ID" },
      // { key: "expid", label: "Exp Id" },
      {
        key: "date",
        label: "Date",
        render: (value) => moment(value).format("DD-MM-YYYY"),
      },
      {
        key: "expenseCategory",
        label: "Category",
        render: (expenseCategory) => expenseCategory?.name || "N/A", // Display category name
      },

      { key: "description", label: "Description" },

      {
        key: "documentPath",
        label: "Document",
        render: (documentPath) => {
          if (!documentPath) return "No Document";

          const fileUrl = `${REACT_APP_BACKEND_URL}/${documentPath}`;
          const isImage = /\.(jpg|jpeg|png|gif)$/i.test(documentPath);
          const isPDF = /\.pdf$/i.test(documentPath);

          return (
            <div>
              {isImage && (
                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                  <img
                    src={fileUrl}
                    alt="Uploaded Document"
                    style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" }}
                  />
                </a>
              )}
              {isPDF && (
                <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block", marginTop: "5px" }}>
                  View PDF
                </a>
              )}
            </div>
          );
        },
      },
      { key: "amount", label: "Amount" },

      // {
      //   key: "actions",
      //   label: "Action",
      //   render: (value, rowData) => (
      //     <OverlayTrigger
      //       placement="top"
      //       overlay={<Tooltip id={`tooltip-edit-${rowData?.id}`}>Update Details</Tooltip>}
      //     >
      //       <Button size="sm" variant="info" onClick={() => this.handleEditClick(rowData)}>
      //         <i className="fas fa-edit"></i>
      //       </Button>
      //     </OverlayTrigger>
      //   )
      // },
    ];
    if (editAction === true) {
      columns.push({
        key: "actions",
        label: "Action",
        render: (value, rowData) => (
          <>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-edit-${rowData?.id}`}>Update Details</Tooltip>}
            >
              <Button size="sm" variant="outline-info" className="mr-2" onClick={() => this.handleEditClick(rowData)}>
                <i className="fas fa-edit"></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-delete-${rowData?.id}`}>Delete</Tooltip>}
            >
              <Button size="sm" variant="outline-danger" className="mr-2" onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}>
                <i className="fas fa-trash"></i>
              </Button>
            </OverlayTrigger>
          </>
        ),
      });
    }



    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={this.state.loading}
          message="Are you sure you want to delete this Expense?"
        />
        <CommonLoader isLoading={this.state.loading}>
          < >

            {!viewPage && (
              <Card className="shadow-sm rounded border-0">
                <Card.Header className="text-white">
                  <strong>Expense Details</strong>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={this.onSubmit}>
                    {/* <Card className="col-sm-12 main-card"> */}
                    <Row className="mb-3">
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formDescription">
                          <Form.Label className="text-muted required">
                            Project Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="project"
                            value={this.state.projectName}
                            placeholder="Project"
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formProject">
                          <Form.Label className="text-muted required">
                            Choose Category
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            value={this.state.categoryId || ''} onChange={this.handleCategoryChange} name="categoryId">
                            <option value="" disabled>Choose Category...</option>
                            {this.state.categoryDataArray.map((category) => (
                              <option key={category.id} value={category.id}>{category.name}</option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.categoryId && (
                            <small className="text-danger">{this.state.errors.categoryId}</small>
                          )}
                        </span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formAmount">
                          <Form.Label className="text-muted required">
                            Amount
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="amount"
                            value={this.state.amount}
                            placeholder="Amount"
                            onChange={this.handleChange}
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.amount && (
                            <small className="text-danger">{this.state.errors.amount}</small>
                          )}
                        </span>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="expenseDate">
                          <Form.Label className="text-muted required">Expense Date </Form.Label><br />
                          <DatePicker
                            selected={this.state.ExpenseDate}
                            value={this.state.ExpenseDate || ""}
                            className="form-control"
                            onChange={this.handleDateChange}
                            placeholderText="Select Expense Date"

                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.ExpenseDate && (
                            <small className="text-danger">{this.state.errors.ExpenseDate}</small>
                          )}
                        </span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formUploadDoc">
                          <Form.Label className="text-muted">Upload documents</Form.Label>
                          <Form.Control
                            type="file"
                            name="uploadDoc"
                            accept=".pdf, .jpg, .jpeg, .png"
                            // value={this.state.uploadDoc || ''}
                            onChange={this.handleFileChange}
                          />
                        </Form.Group>

                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <Form.Group controlId="formDescription">
                          <Form.Label className="text-muted required">
                            Description
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="description"
                            value={this.state.description || ""}
                            placeholder="Description"
                            onChange={this.handleChange}
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.description && (
                            <small className="text-danger">{this.state.errors.description}</small>
                          )}
                        </span>
                      </Col>
                    </Row>
                    <div className='add-cancel-btn '>
                      <Button type="submit" variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary"
                      >
                        {this.state.editAction ? "Update " : "Add"}
                      </Button>
                      <Button v variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            )
            }
          </ >
          {
            viewPage && (
              <div className="expense-details-table" >
                <div className="expense-details-left">
                  <h4>Expense Details</h4>
                  <OverlayTrigger placement="top" overlay={
                    <Tooltip>Update Status</Tooltip>}>
                    <Button size="sm" variant="outline-info" className="mr-2 info"
                      style={{ marginLeft: '10px', height: '35px', width: '40px', marginTop: '10px' }}
                      onClick={() => this.handleStatusChange(this.state.data)}>
                      <i className="fas fa-sync-alt"></i>
                    </Button>
                  </OverlayTrigger>

                </div>
                <div>
                  <Button variant="outline" className="mt-2 back-button info expense_details-heading" onClick={this.handleBack}><i className="fas fa-arrow-alt-circle-right" aria-hidden="true"></i></Button>
                </div>
              </div>
            )
          }

          <div className="exp_details-view">
            {/* {
              console.log("pankaj", this.props.location.state?.data)
            } */}
            <div className="detail-item"><strong>Emp Id:</strong> {this.state.empId}</div>
            <div className="detail-item"><strong>Name:</strong> {this.state.fullName}</div>
            <div className="detail-item"><strong>Project Name:</strong> {this.state.projectName}</div>

            {fromDate && toDate && (
              <>
                <div className="detail-item"><strong>From:</strong> {fromDate}</div>
                <div className="detail-item"><strong>To:</strong> {toDate}</div>
              </>
            )}

          </div>

          <CommonTableModule columns={columns} data={this.state.expDataByExpId} defaultSort={{ key: "amount", order: "desc" }} />
        </CommonLoader >

        <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Update Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label className="required">Select Status</Form.Label>
                <Form.Control
                  as="select"
                  className="form-select"
                  value={this.state.newStatus}
                  onChange={(e) => this.setState({ newStatus: e.target.value })}
                >
                  <option value="">Select</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showModal: false })} size="sm">
              Cancel
            </Button>
            <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleStatusUpdate} size="sm">
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </div >
    );
  }
}
